import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class, _class2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import BaseAdapter from "../base/BaseAdapter";
import { getShareMessage, urlFormatter, isHTTPUrl, isZZUrl, isZZSellerUrl, isCheckUrl, isHunterUrl, isYigeUrl } from "../../core/utils";
import { beforeLogin } from "../base/LoginAdapter";
var ZZYigeAdapter = (_class = (_class2 = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(ZZYigeAdapter, _BaseAdapter);
  var _super = _createSuper(ZZYigeAdapter);
  function ZZYigeAdapter(native) {
    var _this;
    _classCallCheck(this, ZZYigeAdapter);
    return _this = _super.call(this, native, 'https://s1.zhuanstatic.com/common/yigeapp/static/js/1.0.0/index.min.js', function () {
      _this.YIGEAPP = window.YIGEAPP;
      _this.__sdk = _this.YIGEAPP;
    });
  }
  _createClass(ZZYigeAdapter, [{
    key: "share",
    value: function share(shareMessage, callback) {
      this.YIGEAPP.setRightShareBtn(getShareMessage(shareMessage), callback);
    }
  }, {
    key: "shareDetail",
    value: function shareDetail(obj, callback) {
      var defaultPicPath = 'https://pic2.zhuanstatic.com/bidding/big/n_v1bkujjd2nmb7fmlmfhq4a_5ea9d0b68923e35c.png?w=640&h=480';
      var url = obj.url,
        picPaths = obj.picPaths;
      url = urlFormatter(url);
      picPaths = picPaths || defaultPicPath;
      this.YIGEAPP.setShareData(_objectSpread(_objectSpread({}, obj), {}, {
        url: url,
        picPaths: picPaths
      }), callback);
    }
  }, {
    key: "shareClick",
    value: function shareClick(shareMessage, callback) {
      this.YIGEAPP.setSharePanel(getShareMessage(shareMessage), callback);
    }
  }, {
    key: "shareToAssignPlatform",
    value: function shareToAssignPlatform(shareMessage, callback) {
      this.YIGEAPP.shareToPlatform(getShareMessage(shareMessage), callback);
    }
  }, {
    key: "skipToUrl",
    value: function () {
      var _skipToUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(obj, callback) {
        var targetUrl;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              targetUrl = obj.targetUrl;
              targetUrl = urlFormatter(targetUrl);
              if (!(isZZUrl(targetUrl) || isZZSellerUrl(targetUrl) || isCheckUrl(targetUrl) || isHunterUrl(targetUrl) || isYigeUrl(targetUrl))) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", this.enterUnifiedUrl({
                unifiedUrl: targetUrl
              }, callback));
            case 4:
              this.YIGEAPP.enterPage(_objectSpread(_objectSpread({}, obj), {}, {
                targetUrl: targetUrl
              }), callback);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function skipToUrl(_x, _x2) {
        return _skipToUrl.apply(this, arguments);
      }
      return skipToUrl;
    }()
  }, {
    key: "login",
    value: function login(callback) {
      if (_typeof(callback) === 'object') callback = callback.callback;
      var cookieCallback = function cookieCallback(json) {
        callback(json);
      };
      this.YIGEAPP.login(cookieCallback || function () {});
    }
  }, {
    key: "skipToSearchResult",
    value: function skipToSearchResult(obj, callback) {
      obj.cityId = obj.cityId || '0';
      obj.sortType = obj.sortType || '0';
      obj.startPrice = obj.startPrice || '-1';
      obj.endPrice = obj.endPrice || '-1';
      obj.listType = obj.listType || '0';
      this.YIGEAPP.enterSearchResult(obj, callback);
    }
  }, {
    key: "uploadPhotos",
    value: function uploadPhotos(obj, callback) {
      obj.maxAllowCount = obj.maxAllowCount || '5';
      this.YIGEAPP.uploadPhotos(obj, callback);
    }
  }, {
    key: "close",
    value: function close(callback) {
      if (_typeof(callback) === 'object') {
        callback = callback.callback;
      }
      this.YIGEAPP.close(callback);
    }
  }, {
    key: "chooseAddress",
    value: function chooseAddress() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var addressId = obj.addressId;
      this.YIGEAPP.chooseAddress({
        addressId: addressId || 0
      }, callback);
    }
  }, {
    key: "getMarkLocation",
    value: function getMarkLocation(obj) {
      this.YIGEAPP.enterUnifiedUrl({
        unifiedUrl: '' + "zzyige://jump/core/routePlan/jump?" + "goodLatitude=".concat(obj.lat) + "&goodLongitude=".concat(obj.lon) + "&goodVillage=".concat(encodeURIComponent(obj.name || '')) + "&goodAddress=".concat(encodeURIComponent(obj.address || ''))
      });
    }
  }, {
    key: "setPageBackAction",
    value: function setPageBackAction(callback) {
      this.YIGEAPP.setPageBackAction(function () {
        if (arguments.length <= 0 ? undefined : arguments[0]) {
          return callback.apply(void 0, arguments);
        }
      });
    }
  }, {
    key: "enterUnifiedUrl",
    value: function enterUnifiedUrl() {
      var _this$YIGEAPP;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var url = args[0].unifiedUrl;
      var cb = args[1] || function () {};
      if (isHTTPUrl(url)) {
        this.skipToUrl({
          targetUrl: url
        }, cb);
        return;
      }
      (_this$YIGEAPP = this.YIGEAPP).enterUnifiedUrl.apply(_this$YIGEAPP, args);
    }
  }, {
    key: "registerPageCallback",
    value: function registerPageCallback(callback) {
      var useOrigin;
      if (_typeof(callback) === 'object') {
        useOrigin = callback.useOrigin;
        callback = callback.callback;
      }
      if (useOrigin === true) {
        this.YIGEAPP.registerPageCallback(function (res) {
          callback && callback(res);
        });
      } else {
        this.YIGEAPP.registerPageCallback(function (res) {
          if (res && res.code === '0' && res.pageState === '1') {
            callback && callback(res);
          }
        });
      }
    }
  }]);
  return ZZYigeAdapter;
}(BaseAdapter), _defineProperty(_class2, "pluginName", 'ZZYigeAdapter'), _defineProperty(_class2, "platform", [{
  rule: /yigeapp/i,
  name: 'zzyige',
  scheme: 'zzyige://'
}]), _class2), (_applyDecoratedDescriptor(_class.prototype, "login", [beforeLogin], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype)), _class);
export { ZZYigeAdapter as default };